import * as React from 'react';
import styles from './sidebar.module.css';

export type propsType = {
	text: string;
	propsValue?: any;
	activeClassName: string;
};

export const SidebarList: React.FC<propsType> = (props: any) => {
	const { text, propsValue, activeClassName } = props;

	return (
		<li className={activeClassName}>
			<a className={styles.tabText}>
				{text}
				<p className={styles.info}>
					<span>{propsValue}</span>
				</p>
			</a>
		</li>
	);
};
